import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import { useEffect } from "react";
import { Button, Col, Form, Input, Modal, Row, Tabs } from "antd";
import { locales, mailTemplateAPI, PRODUCTION_URL, TINY_MCE_API_KEY } from "../../api/api";
import { Editor } from "@tinymce/tinymce-react";
import { useDispatch, useSelector } from "react-redux";
import {
  EXPORTER_INCOMING_REQUEST_MAIL_TEMPLATE,
  getEIRTemplate,
  setMailTemplate,
  setMailTemplateSubject
} from "../../store/mailTemplatesSlice";
import { useState } from "react";
import { tabsChange, updateTemplate } from "../../helpers/mailTemplatesHelpers";
import Loader from "../../components/Loader/Loader";
import React from "react";

const { TabPane } = Tabs;
const ExporterIncomingRequestMailTemplate = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation(["FA5-ExporterIncomingRequestMailTemplate"]);
  const { setTitle } = useOutletContext();
  const { exporterIncomingRequestMailTemplate } = useSelector((state) => state.mailTemplates);
  const { isLoading } = useSelector((state) => state.auth);
  useEffect(() => {
    if (!exporterIncomingRequestMailTemplate[locales[0]]) {
      dispatch(getEIRTemplate(locales[0]));
    }
  }, []);

  useEffect(() => {
    setTitle(t("title"));
  }, [t, setTitle]);

  const [modalIsVisible, setModalIsVisible] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  return (
    <>
      {modalIsVisible ? (
        <Modal
          visible={modalIsVisible}
          onCancel={() => {
            setModalIsVisible(false);
          }}
          footer={[
            <Button
              key="ok"
              className="btn btn_v2"
              onClick={() => {
                setModalIsVisible(false);
              }}
            >
              ОК
            </Button>
          ]}
        >
          <p>{modalMessage}</p>
        </Modal>
      ) : null}
      <Row>
        <Col sm={{ span: 24 }} xxl={{ span: 20 }} className={`regular_block`}>
          {isLoading && <Loader />}
          <div>
            <h5>{t("availableVariables")}</h5>
            <p>#FIRSTNAME - {t("FIRSTNAME")}</p>
            <p>#LASTNAME - {t("LASTNAME")}</p>
            <p>#COUNTRY - {t("COUNTRY")}</p>
            <p>#PRODUCT_NAME - {t("PRODUCT_NAME")}</p>
            <p>#TEXT - {t("TEXT")}</p>
            <p>#NUMBER_OF_AVAILABLE_CREDITS - {t("NUMBER_OF_AVAILABLE_CREDITS")}</p>
            <p>{t("BUTTON_EXAMPLE")}</p>
          </div>
          <Tabs
            defaultActiveKey={0}
            onChange={(key) => {
              tabsChange(key, exporterIncomingRequestMailTemplate, dispatch, getEIRTemplate);
            }}
          >
            {locales.map((el, i) => (
              <TabPane tab={el} key={i}>
                <Col span={12}>
                  <p className="mb-12">
                    {t("mailSubject", { ns: "FA5-ExporterIncomingRequestMailTemplate" })}
                  </p>
                  <Form>
                    <Form.Item>
                      <Input
                        value={exporterIncomingRequestMailTemplate[locales[i]]?.subject}
                        onChange={(e) => {
                          dispatch(
                            setMailTemplateSubject({
                              mailTemplate: EXPORTER_INCOMING_REQUEST_MAIL_TEMPLATE,
                              lang: el,
                              subject: e.target.value
                            })
                          );
                        }}
                      />
                    </Form.Item>
                  </Form>
                </Col>
                <Editor
                  inline_styles={true}
                  apiKey={TINY_MCE_API_KEY}
                  plugins={["code"]}
                  value={exporterIncomingRequestMailTemplate[locales[i]]?.template}
                  init={{
                    relative_urls: false,
                    remove_script_host: false,
                    document_base_url: PRODUCTION_URL
                  }}
                  onEditorChange={(content) => {
                    dispatch(
                      setMailTemplate({
                        mailTemplateName: EXPORTER_INCOMING_REQUEST_MAIL_TEMPLATE,
                        mailTemplateContent: content,
                        lang: locales[i]
                      })
                    );
                  }}
                />
                <div>
                  <h5 className="mt-50 mb-24">{t("mailTemplate")}</h5>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: exporterIncomingRequestMailTemplate[locales[i]]?.template
                        ?.replace("#FIRSTNAME", t("FIRSTNAMEex"))
                        ?.replace("#LASTNAME", t("LASTNAMEex"))
                        ?.replace("#COUNTRY", t("COUNTRYex"))
                        ?.replace("#TEXT", t("TEXTex"))
                        ?.replace("#PRODUCT_NAME", t("PRODUCT_NAMEex"))
                        ?.replace(
                          "#NUMBER_OF_AVAILABLE_CREDITS",
                          t("NUMBER_OF_AVAILABLE_CREDITSex")
                        )
                        ?.replace(
                          "#BUTTON_START#",
                          "<a style='padding: 14px 40px; background-color: #343543; color: #fff; display: flex; width: max-content;' href='#LINK'>"
                        )
                        ?.replace("#BUTTON_END#", "</a>")
                    }}
                  ></div>
                </div>
                <Button
                  onClick={() =>
                    updateTemplate(
                      locales[i],
                      exporterIncomingRequestMailTemplate,
                      setModalMessage,
                      setModalIsVisible,
                      mailTemplateAPI.updateExporterRequestTemplate,
                      t,
                      dispatch
                    )
                  }
                  className="btn btn_v2 ml-auto mt-24"
                >
                  {t("buttons.save")}
                </Button>
              </TabPane>
            ))}
          </Tabs>
        </Col>
      </Row>
    </>
  );
};

export default ExporterIncomingRequestMailTemplate;
